export default __webpack_public_path__ + "static/media/profile_logo.3cf0a135.svg";